import React from "react";

import SectionDynamicDogBase from "../SectionDynamicDogBase/SectionDynamicDogBase";

export interface SectionDynamicDogBySizeProps {
	title: string;
	htmlIntro?: string;
	currentDogId: string;
	maxItems: number;
	jumpLinksTitle?: string;
	filteredSizeGroups: string[];
}

export const SectionDynamicDogBySize: React.FC<
	SectionDynamicDogBySizeProps
> = ({
	currentDogId,
	maxItems,
	title,
	htmlIntro,
	jumpLinksTitle,
	filteredSizeGroups,
}) => {
	return (
		<SectionDynamicDogBase
			currentDogId={currentDogId}
			maxItems={maxItems}
			title={title}
			htmlIntro={htmlIntro}
			jumpLinksTitle={jumpLinksTitle}
			sectionName="SectionDynamicDogBySize"
			searchVariables={{ size: filteredSizeGroups }}
			queryParams={{ size: filteredSizeGroups }}
		/>
	);
};

export default SectionDynamicDogBySize;
